var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item,index){return _c('Block',{key:index,attrs:{"title":item.title,"city_url":item.city_url,"cate_url":item.cate_url,"map_url":item.map_url}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }